var CryptoJS = require("crypto-js");

export function encrypt(strMsg) {
    return CryptoJS.AES.encrypt(strMsg, process.env.REACT_APP_CRYPTO_KEY);
};

export function decrypted(strMsgEncrypted) {
    const decryptedBytes = CryptoJS.AES.decrypt(strMsgEncrypted, process.env.REACT_APP_CRYPTO_KEY);
    try {
        return decryptedBytes.toString(CryptoJS.enc.Utf8)
    } catch (ex) {
        return null
    }
};